import { render, staticRenderFns } from "./ChapterTable.vue?vue&type=template&id=44bba9b2&scoped=true"
import script from "./ChapterTable.vue?vue&type=script&lang=js"
export * from "./ChapterTable.vue?vue&type=script&lang=js"
import style0 from "./ChapterTable.vue?vue&type=style&index=0&id=44bba9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bba9b2",
  null
  
)

export default component.exports